<div class="panneau-connecter-lecteur__container">
	<div class="container__content">
		<div class="lecteurs-container" *ngFor="let lecteur of lecteurs">
			<lua-option-data-picker [label]="lecteur" [fullWidth]="true" iconName="smart_card_reader" iconMode="outlined"
				position="left" [isSelected]="selectedLecteur === lecteur" (click)="onSelectLecteur(lecteur)">
			</lua-option-data-picker>
		</div>
		<lua-message-action-en-cours *ngIf="rechercheLecteurs" mainText="Recherche de lecteurs" subText=""
				[loaderSize]="60" [loaderSpeed]="1"></lua-message-action-en-cours>
        <lua-action-principale [isDisabled]="selectedLecteur === '' || connectionInProgress" libelle="Se connecter" (click)="connectLecteur()"></lua-action-principale>
    </div>
</div>
